export enum VARIABLE_TYPES {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  LONG = 'LONG',
  DOUBLE = 'DOUBLE',
  DATE = 'DATE',
  STRING = 'STRING',
  OBJECT = 'OBJECT',
}

export const VARIABLE_TYPES_LABELS = {
  [VARIABLE_TYPES.BOOLEAN]: 'Boolean',
  [VARIABLE_TYPES.INTEGER]: 'Integer',
  [VARIABLE_TYPES.LONG]: 'Long',
  [VARIABLE_TYPES.DOUBLE]: 'Double',
  [VARIABLE_TYPES.DATE]: 'Date',
  [VARIABLE_TYPES.STRING]: 'String',
  [VARIABLE_TYPES.OBJECT]: 'Object',
};

export enum VARIABLE_OBJECT_TYPES {
  CAMUNDA_DATE = 'CAMUNDA_DATE',
  CAMUNDA_DATETIME = 'CAMUNDA_DATETIME',
  CANDIDATE = 'CANDIDATE',
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEE_CONTRACT = 'EMPLOYEE_CONTRACT',
  LEAVE = 'LEAVE',
  OTHER = 'OTHER',
  NULL = 'NULL',
  NULL_ARTIFACT = 'NULL_ARTIFACT',
}

export const VARIABLE_OBJECT_TYPES_LABELS = {
  [VARIABLE_OBJECT_TYPES.CAMUNDA_DATE]: 'Camunda Date',
  [VARIABLE_OBJECT_TYPES.CAMUNDA_DATETIME]: 'Camunda Date Time',
  [VARIABLE_OBJECT_TYPES.CANDIDATE]: 'Candidate',
  [VARIABLE_OBJECT_TYPES.EMPLOYEE]: 'Employee',
  [VARIABLE_OBJECT_TYPES.EMPLOYEE_CONTRACT]: 'Employee Contract',
  [VARIABLE_OBJECT_TYPES.LEAVE]: 'Leave',
  [VARIABLE_OBJECT_TYPES.NULL_ARTIFACT]: 'Null Artifact',
  [VARIABLE_OBJECT_TYPES.NULL]: 'Null',
  [VARIABLE_OBJECT_TYPES.OTHER]: 'Other',
};

export enum BOOLEAN_VALUE {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
